<div class="advertisementSpinner"
     *ngIf="advertisementType == AdvertisementEnum.SQUARE && advertisementObj?.length > 0">
    <a [href]="advertisementObj?.[0]?.linkAdv">
        <img style="width: 100%; height: 100%" class="img-fluid" [src]="advertisementObj?.[0]?.image" alt="">
    </a>
</div>
<div class="advertisementSpinner"
     *ngIf="advertisementType == AdvertisementEnum.EXTEND_BANNER && advertisementObj?.length > 0">
    <a [href]="advertisementObj?.[0]?.linkAdv">
        <img style="object-fit: fill; width: 100%; height: 100%" class="img-fluid" [src]="advertisementObj?.[0]?.image" alt="">
    </a>
</div>
<div class="advertisement" *ngIf="advertisementObj != null">
    <app-offer-product *ngIf="advertisementType == AdvertisementEnum.BANNER_ADV"
                       [advertisement]="advertisementObj"></app-offer-product>
</div>
